/**
 * Bunker Ports Service
 * API client for the bunker-scoped ports surface used by the Trade Operations
 * "Bunker Ports" tab (Fuels flavour only).
 *
 * The behaviour lives in ``portListService`` — every trade module's port list
 * speaks the same contract, so this file only binds it to the bunker endpoints.
 */

import { createPortListService } from './portListService';

const bunkerPortService = createPortListService('bunker', 'bunker');

export default bunkerPortService;
